import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const propTypes = {
  /**
   * Additional custom classes for the fieldset element
   */
  className: PropTypes.string,
  /**
   * Forwards a ref to the input checkbox element
   */
  checkboxRef: PropTypes.object,
  /**
   * Enable border checkbox style
   */
  hasBorder: PropTypes.bool,
  /**
   * the checkbox's ID
   **/
  id: PropTypes.string.isRequired,
  /**
   * Checked on load for uncontrolled inputs.
   * Checked state for controlled inputs.
   **/

  isChecked: PropTypes.bool,
  /**
   * Disables the checkbox
   */
  isDisabled: PropTypes.bool,
  /**
   * Is the checkbox indeterminate
   **/
  isIndeterminate: PropTypes.bool,
  /**
   * Text label for the checkbox
   **/
  label: PropTypes.node.isRequired,
  /**
   * Function that runs on checkbox click.
   * When provided, this will act as a controlled input.
   * The checked state must be managed in the parent,
   * and passed into the `isChecked` prop.
   **/
  onChange: PropTypes.func,
  /**
   * QA data attribute for automated testing
   **/
  qaId: PropTypes.string
};
const defaultProps = {
  className: '',
  checkboxRef: null,
  hasBorder: false,
  id: '',
  isChecked: false,
  isDisabled: false,
  isIndeterminate: false,
  label: '',
  onChange: null,
  qaId: ''
};

// All props are defined here, whether they are used or not,
// in order to prevent them from being passed to the input through checkboxPassthrough
const Checkbox = _ref => {
  let {
    checkboxRef,
    className,
    onChange,
    hasBorder,
    id,
    isChecked,
    isDisabled,
    isIndeterminate,
    label,
    qaId,
    ...checkboxPassthrough
  } = _ref;
  const [checked, setChecked] = useState(isChecked);
  const ref = useRef(null);
  const wrapperClasses = classNames('asc-checkbox-group asc-mtb-1', className, {
    'asc-checkbox-group--bordered': hasBorder,
    'is-disabled': isDisabled
  });
  const toggleCheckboxChange = () => {
    if (typeof onChange === 'function') {
      onChange(id, checked);
    } else {
      setChecked(!checked);
    }
  };
  useEffect(() => {
    const currentRef = checkboxRef ? checkboxRef : ref;
    currentRef.current.indeterminate = isIndeterminate;
    setChecked(isChecked);
  }, [isChecked, isIndeterminate, checkboxRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement("label", {
    className: "asc-form-label",
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    ref: checkboxRef ? checkboxRef : ref,
    type: "checkbox",
    name: id,
    onChange: toggleCheckboxChange,
    checked: !isDisabled && checked,
    disabled: isDisabled,
    "data-qa": qaId
  }, checkboxPassthrough)), typeof label === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: "asc-form-label-text"
  }, label) : label));
};
Checkbox.defaultProps = defaultProps;
Checkbox.propTypes = propTypes;
export default Checkbox;